import { AuthState } from '@slices/auth';

import { appCreateSelector, RootState } from '@store';

export const authGet = (state: RootState): AuthState => {
  return state.app.auth;
};

export const authGetIsAuthorized: (
  state: RootState //
) => boolean = appCreateSelector(
  [authGet], //
  (auth) => auth.isAuthorized
);

export const authGetIsTestingUser: (
  state: RootState //
) => boolean = appCreateSelector(
  [authGet], //
  (auth) => auth.isTestingUser
);
